import React, { useMemo } from 'react';

const StarsBackground = () => {
  const stars = useMemo(() => {
    return [...Array(120)].map((_, i) => ({
      id: i,
      width: Math.random() * 2.5 + 0.5,
      top: Math.random() * 100,
      left: Math.random() * 100,
      opacity: Math.random() * 0.6 + 0.2,
      duration: Math.random() * 4 + 2,
    }));
  }, []);

  return (
    <div className="stars-bg" aria-hidden="true">
      {stars.map(star => (
        <div
          key={star.id}
          className="star"
          style={{
            width: star.width + 'px',
            height: star.width + 'px',
            top: star.top + '%',
            left: star.left + '%',
            '--opacity': star.opacity,
            '--duration': star.duration + 's',
          }}
        />
      ))}
    </div>
  );
};

export default StarsBackground;
